export default class BRecaptchaForm
{
	static selector = () => `.b-recaptcha-form`;

	static addEventListeners()
	{
		document.addEventListener(`submit`, function (event) {
			if (event.target.matches(BRecaptchaForm.selector())) {
				if (!event.target.querySelector(`[name="recaptchaToken"]`)) {
					let input = document.createElement("input");
					input.type = `hidden`;
					input.name = `recaptchaToken`;

					event.target.append(input);
				}

				let tokenInput = event.target.querySelector(`[name="recaptchaToken"]`);
				if (!tokenInput?.value) {
					event.preventDefault();
					event.stopPropagation();

					grecaptcha.enterprise.ready(function () {
						grecaptcha.enterprise.execute(_config.recaptcha.key, {
							action: "SUBMIT_FORM",
						}).then(function (token) {
							tokenInput.value = token;
							event.target.submit();
						});
					});
				}
			}
		}, {
			capture: true,
		});
	}
}
